import { Button, Card, Col, Divider, Input, Layout, Row, Table, Tag, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import CoinImage from "../../img/einstein-coin-40px.png";
import LinkImage from "../../img/link-icon-64px.svg";
import CoinsImage from "../../img/3-einstein-coins.svg";
import SteeringIcon from "../../img/steering-wheel-icon-64px.svg";
import CoinImage40 from "../../img/einstein-coin-40px.png";
import Link40 from "../../img/link-icon-40px.svg";
import Stickman40 from "../../img/stickman-icon-40px.svg";
import EinsteinWallpaper from "../../img/einstein-wallpaper.png";
import SpendThumb from "../../img/how_spend_thumb.png";
import GetThumb from "../../img/where_get_thumb.png";
import { http } from "../../helpers/http";
import { useTranslation } from "react-i18next";
import moment from "moment";
import 'moment/locale/lv';
import FriendRefferalImg from "../../img/friend-referral.png";
import { WhatsAppOutlined, MailOutlined } from '@ant-design/icons';

type CoinsLayoutProps = {
    refreshBalance: () => void;
    bonus: string;
    student: any;
}

const styles = {
    miniCard: {
        display: "inline-flex",
        alignItems: "center",
        flexDirection: "column",
        marginBottom: 10,
        padding: "40px 24px",
        border: "1px solid #CED4D9",
        borderRadius: 4,
        boxShadow: " 0px 3px 6px 0px rgba(64, 96, 128, 0.10)",
        width: "100%",
        height: "100%"
    } as React.CSSProperties,
}

export const CoinsLayout = ({ ...props }: CoinsLayoutProps) => {
    const { t } = useTranslation();
    const [code, setCode] = useState('' as any);
    const [email, setEmail] = useState('' as any);
    const [uniqueRefHash, setUniqueRefHash] = useState('' as any);
    const [history, setHistory] = useState([] as any);
    const [isLearnMoreVisible, setIsLearnMoreVisible] = useState(false);
    const learnMoreList = Object.values(t('bonus.learn_more_list', { returnObjects: true })) as string[];

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkSize = () => setIsMobile(window.innerWidth <= 1024); 
        checkSize();
        window.addEventListener("resize", checkSize);
        return () => window.removeEventListener("resize", checkSize);
    }, []);

    const columns = [
        {
            title: t('bonus.received_date'),
            dataIndex: "created_at",
            render: (date: string) => {
                return moment(date).format("DD.MM.YYYY")
            }
        },
        {
            title: t('bonus.friend_email'),
            dataIndex: "email",
        },
        {
            title: t('bonus.earned_einsteins'),
            dataIndex: "amount",
            render: (amount: string) => {
                return <div>
                    <img style={{ width: 20, height: 20, marginRight: 8 }} src={CoinImage} alt="Einstein coins" />
                    <span style={{ color: "#059DC1", fontWeight: "bold" }}>+{amount} EIN</span>
                </div>
            }
        },
        // {
        //     title: t('common.status'),
        //     dataIndex: "claimed",
        //     render: (claimed: 1 | 0) => {
        //         return claimed === 1 ? <span style={{ color: "#1A804D" }}>{t('common.accepted')}</span> : <span style={{ color: "orange" }}>{t('common.awaiting_accept')}</span>
        //     }
        // },
        {
        title: t('bonus.valid_until'),
        dataIndex: "updated_at",
        render: (updatedAt: string) => {
            const futureDate = moment(updatedAt).add(60, 'days').format('D. MMMM YYYY HH:mm');
            return <span style={{ color: "#1A804D" }}>{futureDate}</span>;
        }
        }
    ]

    const assignScholarship = () => {
        if (code === '') return;
        http.post('assign-scholarship', { code }).then((response: any) => {
            if (response.data.data === "wrong_code") return message.error(t('errors.wrong_code'));
            //console.log(response)
            props.refreshBalance();
            setCode('');
            message.success(t('bonus.bonus_assigned'))
        }).catch((error: any) => {
            message.error(t('errors.error'));
        });
    }

    const sendAffiliateRequest = () => {
        if (email === '') return;
        http.post('send-affiliate-request', { email }).then((response: any) => {
            setEmail('');
            message.success(t('bonus.request_sent'))
        }).catch((error: any) => {
            message.error(t('errors.error'));
        });
    }

   const renderLearnMoreModal = () => (
    <Modal
        title={t('bonus.learn_more_modal_title')}
        visible={isLearnMoreVisible}
        onCancel={() => setIsLearnMoreVisible(false)}
        style={{ borderRadius: 16, overflow: "hidden" }}
        footer={[
            <Button key="close" onClick={() => setIsLearnMoreVisible(false)}>
            {t('common.close')}
            </Button>,
        ]}
        width={720}
        >
        <div style={{ maxHeight: "70vh", overflowY: "auto", paddingRight: 8 }}>
            {/* Intro Descriptions */}
            <p style={{ marginBottom: 12 }}>{t('bonus.learn_more_modal_description_1')}</p>
            <p style={{ marginBottom: 24 }}>{t('bonus.learn_more_modal_description_2')}</p>

            {/* How to earn */}
            <h3 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 16 }}>
            {t('bonus.how_to_earn_einsteins_title')}
            </h3>
            {[1, 2, 3, 4, 5].map(i => (
            <p key={i} style={{ fontSize: 14, marginBottom: 8 }}>{t(`bonus.how_to_earn_einsteins_list_${i}`)}</p>
            ))}

            {/* How to use */}
            <h3 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 16 }}>
            {t('bonus.how_to_use_einsteins_title')}
            </h3>
            <p style={{ fontSize: 14, marginBottom: 12 }}>{t('bonus.how_to_use_einsteins_list_1')}</p>

            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 8 }}>
            {t('bonus.how_to_use_einsteins_list_2')}
            </div>
            {[3, 4].map(i => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <div style={{ paddingRight: 8 }}>•</div>
                <div style={{ fontSize: 14 }}>{t(`bonus.how_to_use_einsteins_list_${i}`)}</div>
            </div>
            ))}

            <div style={{ fontSize: 14, fontWeight: 500, marginTop: 12, marginBottom: 8 }}>
            {t('bonus.how_to_use_einsteins_list_5')}
            </div>
            {[6, 7, 8, 9].map(i => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 6 }}>
                <div style={{ paddingRight: 8 }}>•</div>
                <div style={{ fontSize: 14 }}>{t(`bonus.how_to_use_einsteins_list_${i}`)}</div>
            </div>
            ))}

            <p style={{ marginTop: 16 }}>{t('bonus.how_to_use_einsteins_description')}</p>

            {/* Good to know */}
            <h3 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 16 }}>
            {t('bonus.good_to_know_title')}
            </h3>
            {[1, 2, 3, 4].map(i => (
            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 8 }}>
                <div style={{ paddingRight: 8 }}>•</div>
                <div style={{ fontSize: 14 }}>{t(`bonus.good_to_know_list_${i}`)}</div>
            </div>
            ))}

            {/* Start today */}
            <h3 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 16 }}>
            {t('bonus.start_today_title')}
            </h3>
            {[1, 2, 3].map(i => (
            <p key={i} style={{ fontSize: 14, marginBottom: 8 }}>{t(`bonus.start_today_list_${i}`)}</p>
            ))}

            <p style={{ marginTop: 16 }}>{t('bonus.start_today_description_1')}</p>
            <p style={{ fontWeight: 600 }}>{t('bonus.start_today_description_2')}</p>
        </div>
    </Modal>
    );

    // const getUniqueRefHash = () => {
    //     http.get('get-affiliate-hash').then((response: any) => {
    //         setUniqueRefHash((process.env.REACT_APP_STUDENT_URL ?? "https://student.einsteins.lv/") + "ref/" + response.data);
    //     }).catch((error: any) => {
    //         message.error(t('errors.error'));
    //     });
    // }
    const getUniqueRefHash = () => {
    http.get('get-affiliate-hash').then((response: any) => {
        //const baseRefUrl = "https://demo24.datateks.lv/lv/ref/"; // fixed domain
        const baseRefUrl = "https://einsteins.lv/lv/ref/";
        setUniqueRefHash(baseRefUrl + response.data);
    }).catch((error: any) => {
        message.error(t('errors.error'));
    });
};

    // const getHistory = () => {
    //     http.get('get-my-affiliates').then((response: any) => {
    //         console.log(response.data);
    //         setHistory(response.data.data);
    //     }).catch((error: any) => {
    //         message.error(t('errors.error'));
    //     });
    // }
    const getHistory = () => {
        http.get('get-my-affiliates').then((response: any) => { // a sprincle of filter on this bih
            const filtered = response.data.data.filter((entry: any) => entry.claimed === 1);
            setHistory(filtered);
        }).catch((error: any) => {
            message.error(t('errors.error'));
        });
    };

    useEffect(() => {
        getUniqueRefHash();
        getHistory();
    }, [])

    return <Layout className="main-content">
        <Card style={{ marginBottom: 24, borderRadius: 8, padding: 0 }}>
        <div
            style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "stretch" : "center",
            }}
        >
            <div
            style={{
                flex: isMobile ? "none" : "0 0 289px",
                height: isMobile ? "auto" : 160,
                overflow: "hidden",
            }}
            >
            <img
                src={FriendRefferalImg}
                alt="Referral"
                style={{
                width: "100%",
                height: isMobile ? "auto" : "100%",
                objectFit: "cover",
                borderTopLeftRadius: 8,
                borderTopRightRadius: isMobile ? 8 : 0,
                borderBottomLeftRadius: isMobile ? 0 : 8,
                }}
            />
            </div>

            <div
            style={{
                flex: 1,
                padding: 24,
                borderTop: isMobile ? "1px solid #E0E0E0" : "none",
                borderLeft: isMobile ? "none" : "1px solid #E0E0E0",
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? 16 : 24,
                alignItems: isMobile ? "flex-start" : "center",
                justifyContent: "space-between",
            }}
            >

            <div style={{ flex: 1 }}>
                <div style={{ fontSize: 21, fontWeight: 700, marginBottom: 16 }}>
                    {t('bonus.invite_headline', { amount: 10 })}
                </div>
                <div style={{ fontSize: 14, lineHeight: 1.5, marginBottom: 16 }}>
                    {t('bonus.invite_description', { amount: 10 })}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <img src={CoinImage} alt="Coin" style={{ width: 16, height: 16 }} />
                <span style={{ fontSize: 13 }}>
                    <strong>{t('bonus.conversion_rate')}</strong>
                </span>
                </div>
            </div>

            <div
                style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginTop: isMobile ? 8 : 0,
                alignSelf: isMobile ? "center" : "auto",
                }}
            >
                <img src={CoinImage} alt="Coin" style={{ width: 64, height: 64 }} />
                <div style={{ textAlign: isMobile ? "center" : "left" }}>
                <div style={{ fontSize: 12, color: "#777" }}>{t('bonus.my_einsteins')}</div>
                <div style={{ fontSize: 18, fontWeight: 700 }}>{props.bonus}</div>
                </div>
            </div>
            </div>
        </div>
        </Card>
        
        {/* next - referral cardish */}
        <Row gutter={[24, 24]} style={{ marginTop: 24, marginBottom: 24 }} align="stretch">
        <Col xs={24} lg={12}>
        <div
            style={{
            height: "100%",
            borderRadius: 16,
            overflow: "hidden",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.05)",
            background: "#fff",
            }}
        >
            <div
            style={{
                backgroundColor: "#482E80",
                padding: "28px 24px",
            }}
            >
            <h3 style={{ color: "#FFFFFF", fontSize: 21, fontWeight: 700, margin: 0 }}>
                {t('bonus.referral_title')}
            </h3>
            </div>

            <Card
            bordered={false}
            bodyStyle={{ padding: 24 }}
            style={{ borderRadius: 0 }}
            >
            <Input.Group compact style={{ marginBottom: 16 }}>
                <Input
                style={{
                    width: "calc(100% - 76px)",
                    height: 44,
                    borderRadius: "8px 0 0 8px",
                    fontSize: 14,
                    backgroundColor: "#F9F9F9",
                    borderColor: "#E0E0E0",
                }}
                value={uniqueRefHash}
                readOnly
                />
                <Button
                onClick={() => {
                    try {
                    navigator.clipboard.writeText(uniqueRefHash);
                    message.success(t('common.link_copied'));
                    } catch (e) {
                    message.error(t('common.link_copy_failed'));
                    }
                }}
                style={{
                    width: 76,
                    height: 44,
                    borderRadius: "0 8px 8px 0",
                    fontWeight: 600,
                    fontSize: 14,
                }}
                >
                {t('common.copy')}   
                </Button>
            </Input.Group>

            <Divider
                orientation="center"
                style={{
                    borderColor: "#E0E0E0",
                    color: "#2D0D57",
                    fontSize: 14,
                    margin: "16px 0",
                }}
                >
                {t('bonus.or_send_another_way')}
            </Divider>

            <Row gutter={12} justify="center">
                <Col>
                <Button
                    icon={<WhatsAppOutlined style={{ fontSize: 20, verticalAlign: 'middle' }} />}
                    style={{
                        backgroundColor: "#61D66A",
                        borderColor: "#61D66A",
                        color: "#FFFFFF",
                        fontWeight: 600,
                        fontSize: 16,
                        minWidth: 260,
                        height: 48,
                        borderRadius: 12,
                        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => {
                        const lines = [
                            t('bonus.invite_friendly_intro_0') + ' 😎',
                            t('bonus.invite_friendly_intro_1'),
                            "",
                            ' 👉' + t('bonus.invite_friendly_intro_2', { amount: 10 }) ,
                            "",
                            t('bonus.invite_friendly_intro_3', { link: uniqueRefHash }),
                            "",
                            t('bonus.invite_friendly_intro_4') + ' 🛞🔥',
                            ];

                            const messageText = lines.join('\n');
                            //const whatsappURL = `https://api.whatsapp.com/send?text=${(messageText)}`; this goes without nextline
                            const whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(messageText)}`;
                            window.open(whatsappURL, '_blank');
                        }}
                    >
                    Whatsapp
                    </Button>
                </Col>

                <Col>
                <Button
                    icon={<MailOutlined style={{ fontSize: 20, verticalAlign: 'middle' }} />}
                    style={{
                        backgroundColor: "#F6F7FB",
                        borderColor: "#F6F7FB",
                        color: "#2D0D57",
                        fontWeight: 600,
                        fontSize: 16,
                        minWidth: 260,
                        height: 48,
                        borderRadius: 12,
                        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.04)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => {
                        const subject = encodeURIComponent(t('bonus.invite_email_subject', { amount: 10 }) as string);

                        const emailLines = [
                            t('bonus.invite_friendly_intro_0') + ' 😎',
                            t('bonus.invite_friendly_intro_1'),
                            "",
                            ' 👉' + t('bonus.invite_friendly_intro_2', { amount: 10 }) ,
                            "",
                            t('bonus.invite_friendly_intro_3', { link: uniqueRefHash }),
                            "",
                            t('bonus.invite_friendly_intro_4') + ' 🛞🔥',
                        ];

                        const body = encodeURIComponent(emailLines.join('\n'));
                        const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
                        window.open(mailtoLink, '_blank');
                    }}
                    >
                    E-pasts
                    </Button>
                </Col>
                </Row>
            </Card>
        </div>
        </Col>

        {/* How It Works cardish*/}
        <Col xs={24} lg={12}>
            <Card
                bodyStyle={{ padding: 24 }}
                style={{
                height: "100%",
                borderRadius: 24,
                background: "#ffffff",
                boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.05)",
                }}
            >
                <h3 style={{ fontWeight: 700, fontSize: 18, marginBottom: 24 }}>
                    {t('bonus.how_it_works')}
                </h3>
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                    {Object.values(t('bonus.how_it_works_list', { returnObjects: true }) || {}).map((text, index, array) => (
                        <div key={index} style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
                            <div
                                style={{
                                    minWidth: 28,
                                    height: 28,
                                    borderRadius: "50%",
                                    backgroundColor: "#2D0D57",
                                    color: "#fff",
                                    fontWeight: 700,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 14,
                                    marginTop: 2
                                }}
                            >
                                {index + 1}
                            </div>
                            <div
                                style={{
                                    fontSize: 14,
                                    color: index === array.length - 1 ? "red" : "#333",
                                    fontWeight: index === array.length - 1 ? "bold" : "normal"
                                }}
                            >
                                {text as string}
                            </div>
                        </div>
                    ))}
                    <div>
                        <Button type="link" onClick={() => setIsLearnMoreVisible(true)}>
                            {t('app.learn_more')} →
                        </Button>
                    </div>
                </div>
            </Card>
            </Col>
        </Row>
        {/* <Card style={{ marginBottom: 32 }} bodyStyle={{ padding: 32 }}>
            <h2>{t('bonus.earn_bonus')}</h2>
            <Row gutter={16}>
                <Col span={24} lg={8}>
                    <div style={styles.miniCard}>
                        <img style={{ width: 64, height: 64, marginBottom: 20 }} src={LinkImage} alt="Link icon" />
                        <div>
                            <h3 style={{ fontWeight: "bold", marginBottom: 8, textAlign: "center" }}>{t('bonus.invite_friend')}</h3>
                            <p style={{ margin: 0 }}>{t('bonus.invite_friend_content')}</p>
                        </div>
                    </div>
                </Col>
                <Col span={24} lg={8}>
                    <div style={styles.miniCard}>
                        <img style={{ width: 64, height: 64, marginBottom: 20 }} src={CoinsImage} alt="3 Coins icon" />
                        <div>
                            <h3 style={{ fontWeight: "bold", marginBottom: 8, textAlign: "center" }}>{t('bonus.get_einsteins')}</h3>
                            <p style={{ margin: 0 }}>{t('bonus.get_einsteins_content')}</p>
                        </div>
                    </div>
                </Col>
                <Col span={24} lg={8}>
                    <div style={styles.miniCard}>
                        <img style={{ width: 64, height: 64, marginBottom: 20 }} src={SteeringIcon} alt="Steering wheel icon" />
                        <div>
                            <h3 style={{ fontWeight: "bold", marginBottom: 8, textAlign: "center" }}>{t('bonus.spend_expedient')}</h3>
                            <p style={{ margin: 0 }}>{t('bonus.spend_expedient_content')}</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Card> */}
        <Card
            bodyStyle={{ padding: "32px" }}
            style={{
                marginBottom: 32,
                borderRadius: 16,
                boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.05)", 
                overflow: "hidden" 
            }}
        >
            {/* <Row style={{ padding: 24, background: "#CED4D9", marginBottom: 8 }} justify="space-between" align="middle">
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                    <img style={{ width: 40, height: 40, marginRight: 16 }} src={CoinImage40} alt="Einstein coins" />
                    <div>
                        <p style={{ margin: 0 }}>{t('common.in_your_account')}</p>
                        <h3 style={{ fontWeight: "bold", marginBottom: 0 }}>{props.bonus} EIN</h3>
                    </div>
                </div>
            </Row> */}
            {/* {
                props.student?.category?.use_affiliate === 1
                && <Row
                    style={{ padding: 24, border: "1px solid #CED4D9", marginBottom: 8, boxShadow: " 0px 3px 6px 0px rgba(64, 96, 128, 0.10)" }}
                    justify="space-between"
                    align="middle"
                >
                    <Col span={24} lg={12} style={{ display: "inline-flex", alignItems: "center", marginBottom: 10 }}>
                        <img style={{ width: 40, height: 40, marginRight: 16 }} src={Link40} alt="unique link" />
                        <div>
                            <h3 style={{ fontWeight: "bold", marginBottom: 0 }}>{t('bonus.unique_link')}</h3>
                            <p style={{ margin: 0 }}>{t('bonus.invite_friends_and_get')}</p>
                        </div>
                    </Col>
                    <Col style={{ display: "inline-flex", alignItems: "center", width: 300 }}>
                        <div style={{ position: "relative" }}>
                            <Input
                                style={{ width: 300, height: 38, backgroundColor: "#F0F2F5", paddingRight: 80 }}
                                value={uniqueRefHash}
                            />
                            <Button
                                type="primary"
                                style={{ position: "absolute", right: 3, top: 3 }}
                                onClick={() => { try { navigator.clipboard.writeText(uniqueRefHash); message.success('Saite nokopēta') } catch (e) { message.error('Neizdevās nokopēt saiti') } }}
                            >
                                {t('common.copy')}
                            </Button>
                        </div>

                    </Col>
                </Row>
            } */}
            {/* {
                !!!props.student?.has_promo
                && <Row style={{ padding: 24, border: "1px solid #CED4D9", marginBottom: 8, boxShadow: " 0px 3px 6px 0px rgba(64, 96, 128, 0.10)" }} justify="space-between" align="middle">
                    <Col span={24} lg={12} style={{ display: "inline-flex", alignItems: "center", marginBottom: 10 }}>
                        <img style={{ width: 40, height: 40, marginRight: 16 }} src={Link40} alt="unique code" />
                        <div>
                            <h3 style={{ fontWeight: "bold", marginBottom: 0 }}>{t('bonus.write_code')}</h3>
                            <p style={{ margin: 0 }}>{t('bonus.write_code_for_bonus')}</p>
                        </div>
                    </Col>
                    <Col style={{ display: "inline-flex", alignItems: "center", width: 300 }}>
                        <div style={{ position: "relative" }}>
                            <Input
                                style={{ width: 300, height: 38, backgroundColor: "#F0F2F5", paddingRight: 115 }}
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                            />
                            <Button
                                type="primary"
                                style={{ position: "absolute", right: 3, top: 3 }}
                                onClick={assignScholarship}
                                disabled={code === ''}
                            >
                                {t('common.confirm')}
                            </Button>
                        </div>

                    </Col>
                </Row>
            } */}
            {/* {
                props.student?.category?.use_affiliate === 1
                && <Row style={{ padding: 24, border: "1px solid #CED4D9", marginBottom: 32, boxShadow: " 0px 3px 6px 0px rgba(64, 96, 128, 0.10)" }} justify="space-between" align="middle">
                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                        <img style={{ width: 40, height: 40, marginRight: 16 }} src={Stickman40} alt="invite friend" />
                        <div>
                            <h3 style={{ fontWeight: "bold", marginBottom: 0 }}>{t('bonus.invite_with_email')}</h3>
                            <p style={{ margin: 0 }}>{t('bonus.invite_friends_and_get')}</p>
                        </div>
                    </div>
                    <Col style={{ display: "inline-flex", alignItems: "center", width: 300 }}>
                        <div style={{ position: "relative" }}>
                            <Input
                                style={{ width: 300, height: 38, backgroundColor: "#F0F2F5", paddingRight: 105 }}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                            />
                            <Button
                                type="primary"
                                style={{ position: "absolute", right: 3, top: 3 }}
                                onClick={sendAffiliateRequest}
                                disabled={email === ''}
                            >
                                {t('bonus.invite')}
                            </Button>
                        </div>

                    </Col>
                </Row>
            } */}
            <h2>{t('bonus.activity_history')}</h2>
            <Table
                columns={columns}
                dataSource={history}
            />
        </Card>
        {/* <Card bodyStyle={{ padding: 32 }}>
            <h2>{t('bonus.earn_bonus')}</h2>
            <Row id="what_is_einsteins" gutter={16}>
                <Col span={24} md={18}>
                    <h2 style={{ fontWeight: "bold", marginBottom: 8 }}>{t('bonus.what_is_einsteins')}</h2>
                    <p>{t('bonus.what_is_einsteins_content')}</p>
                    <Tag color="blue" style={{ marginBottom: 20 }}>1 Einšteins = 1 EUR</Tag>
                </Col>
                <Col span={24} md={6}>
                    <img style={{ width: "100%" }} src={EinsteinWallpaper} alt="Einstein coin wallpaper with background" />
                </Col>
            </Row>
            <Divider />
            <Row id="where_spend" gutter={16}>
                <Col span={24} md={18}>
                    <h2 style={{ fontWeight: "bold", marginBottom: 8 }}>{t('bonus.where_spend_einsteins')}</h2>
                    <p>{t('bonus.where_spend_einsteins_content')}</p>
                </Col>
                <Col span={24} md={6}>
                    <img style={{ width: "100%" }} src={SpendThumb} alt="Where to spend thumbnail of manual image" />
                </Col>
            </Row>
            <Divider />
            <Row id="where_get" gutter={16}>
                <Col span={24} md={18}>
                    <h2 style={{ fontWeight: "bold", marginBottom: 8 }}>{t('bonus.where_get_einsteins')}</h2>
                    <p>{t('bonus.where_get_einsteins_content')}</p>
                </Col>
                <Col span={24} md={6}>
                    <img style={{ width: "100%" }} src={GetThumb} alt="Where to get thumbnail of manual image" />
                </Col>
            </Row>
        </Card> */}
        {renderLearnMoreModal()}
    </Layout>
}